export default {
    'barraLateral.label.cerrarSesion': 'Cerrar Sesión',
    'barraLateral.label.lenguajes': 'Lenguajes',
    'barraLateral.label.selector': 'Selector de aplicaciones',
    'barraLateral.title.logo': 'Inicio',
    'barraLateral.title.perfil': 'Perfil',
    'base.alerta.errorConexion': 'No se pudo establecer la conexión con el servicio.',
    'base.observadorRespuestaREST.mensajeSesionExpirada': 'Su sesión expiro',
    'base.observadorRespuestaREST.tituloSesionExpirada': 'Aviso',
    'base.alerta.seleccionarAgencia': 'Seleccione una agencia para continuar',
    'button.paginaNoEncontrada': 'Regresar',
    'comunes.alerta.agenciaNoSeleccionada': 'Por favor seleccione una agencia',
    'comunes.alerta.camposIncompletos': 'Por favor ingrese todos los campos requeridos (*)',
    'comunes.alerta.usuarioSinAgencia': 'Este usuario no cuenta con una agencia asignada',
    'comunes.alerta.usuarioSinAplicacion': 'Este usuario no cuenta con una aplicación asignada',
    'label.sinRegistros': 'No se encontraron registros',
    'lenguajes.label.en': 'Ingles',
    'lenguajes.label.es': 'Español',
    'login.inicioSesion': 'Iniciar Sesión',
    'login.placeHolderContrasena': 'Ingrese su contraseña',
    'login.placeHolderUsuario': 'Ingrese su usuario',
    'login.sesion.invalida': 'Su sesión expiro por favor ingrese nuevamente',
    'login.sesion.sesionExpirada': 'Su sesión expiro por inactividad',
    'selectorIdioma.tooltip': 'Cambiar idioma',
    'sidebar.app': 'Aplicación',
    'subtitle.paginaNoEncontrada': 'Página no encontrada',
    'title.paginaNoEncontrada': '404',
    'label.inputImagen.limiteImagen': 'Imagen',
    'label.inputImagen.limiteImagenes': 'Imágenes',
    'label.inputImagen.maximo': 'Máximo',
    /* labels tabla */
    'materialTable.emptyDataSourceMessage': 'No se han encontrado registros.',
    'materialTable.saveTooltip': 'Guardar',
    'materialTable.cancelTooltip': 'Cancelar',
    'materialTable.deleteText': '¿Está seguro que desea eliminar este registro?',
    'materialTable.addTooltip': 'Agregar',
    'materialTable.deleteTooltip': 'Eliminar',
    'materialTable.editTooltip': '¿Está seguro que desea editar este registro?',
    'materialTable.actions': 'Acciones',
    'materialTable.groupedBy': 'Agrupados por',
    'materialTable.placeholder': 'Arrastrar encabezados ...',
    'materialTable.firstTooltip': 'Primera página',
    'materialTable.labelDisplayedRows': 'de',
    'materialTable.previousTootip': 'Página anterior',
    'materialTable.nextTooltip': 'Página siguiente',
    'materialTable.labelRowsPerPage': 'Filas por páginas',
    'materialTable.lastTooltip': 'Última página',
    'materialTable.labelRowsSelect': 'Filas',
    'materialTable.addRemoveColumns': 'Mostrar/Ocultar columnas',
    'materialTable.nRowsSelected': 'filas seleccionadas',
    'materialTable.showColumnsTitle': 'Mostrar columnas',
    'materialTable.showColumnsAriaLabel': 'Mostrar columnas',
    'materialTable.exportAriaLabel': 'Exportar',
    'materialTable.exportTitle': 'Exportar',
    'materialTable.exportCSVName': 'Exportar como CSV',
    'materialTable.exportPDFName': 'Exportar como PDF',
    'materialTable.searchTooltip': 'Buscar',
    'Comunes.ExportarXLSX': 'Exportar a Excel',
    'Comunes.Si': 'Si',
    'Comunes.No': 'No',
    'Comunes.Activo': 'Activo',
    'Comunes.Inactivo': 'Inactivo',
};
